<template>
  <div>
    <v-dialog
      v-model="messageDialog"
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar
          dark
          color="primary">
          <v-btn
            icon
            dark
            @click="closeMessageDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>Send SMS
        </v-toolbar>
        <v-card-title>{{contactName}} <br>
          {{mobileNumber}}</v-card-title>
        <v-card-text>
          <ValidationObserver ref="messageTemplate" v-slot="{ invalid, valid, errors }">
            <v-form v-model="messageTemplateValid">
              <v-select
                v-if="showTemplates"
                v-model="selectedMessage"
                :items="messageTemplates"
                item-text="shortDescription"
                item-value="messageText"
                label="Select message"
                single-line
                dense
                @change="setSelectedMessage"
                hide-details="auto">
              </v-select>

              <ValidationProvider
                            rules="required"
                            name="Message text"
                            vid="messageText"
                            v-slot="{ errors }">
                <v-textarea
                  required
                  :error-messages="errors"
                  v-model="messageText">
                </v-textarea>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="green darken-1"
            primary
            class="justify-end white--text"
            @click="sendMessage">
            <v-icon>mdi-cellphone-text</v-icon> Send
          </v-btn>
          <v-btn
            color="red darken-1"
            primary
            class="justify-end white--text"
            @click="closeMessageDialog">
            <v-icon>mdi-cellphone-erase</v-icon> Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import storeConstants from '@/store/storeConstants';

setInteractionMode('eager');

extend('required', required);

export default {
  name: 'SmsSender',
  props: {
    messageType: {
      type: Number,
      default: 1, // 1: Passenger, 2: Driver
    },
    messageDialog: {
      type: Boolean,
      default: false,
    },
    bookingNumber: {
      type: Number,
      default: undefined,
    },
    mobileNumber: {
      type: String,
      default: undefined,
    },
    contactName: {
      type: String,
      default: undefined,
    },
    messageTemplates: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    messageText: undefined,
    selectedMessage: undefined,
    messageTemplateValid: false,
  }),
  computed: {
    ...mapGetters([
      storeConstants.MESSAGE_TEMPLATES]),
    showTemplates() {
      return this.messageType === 1;
    },
  },
  methods: {
    ...mapActions([storeConstants.SEND_TEXT_MESSAGE,
      storeConstants.SEND_DRIVER_TEXT_MESSAGE,
      storeConstants.GET_MESSAGE_TEMPLATES]),
    sendMessage() {
      this.$refs.messageTemplate.validate().then((success) => {
        this.messageTemplateValid = success;
        if (this.messageTemplateValid) {
          let data = {};
          switch (this.messageType) {
            case 1:
              data = {
                messageType: 1,
                bookingNumber: this.bookingNumber,
                messageText: this.messageText,
              };
              break;
            case 2:
              data = {
                messageType: 2,
                mobileNumber: this.mobileNumber,
                messageText: this.messageText,
              };
              break;
            default:
              // TODO: Throw error here.
              break;
          }

          this.SEND_TEXT_MESSAGE(data).then((result) => {
            if (result) {
              this.selectedMessage = undefined;
              this.messageText = '';
              this.$emit(storeConstants.EVT_CLOSE_SMS_SENDER);
            }
          }).catch(() => { });
        }
      });
    },
    setSelectedMessage(message) {
      this.messageText = message;
    },
    closeMessageDialog() {
      this.$emit(storeConstants.EVT_CLOSE_SMS_SENDER);
      this.selectedMessage = undefined;
      this.messageText = '';
    },
  },
};
</script>
